import { SORT_ASCENDING, SORT_DESCENDING } from "./constants";
export function toggleSortDirection(inputDirection) {
  return inputDirection === SORT_DESCENDING ? SORT_ASCENDING : SORT_DESCENDING;
}